import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";
import SEO from "../components/SEO";

const faqs = [
  { q: "How do your tanks fit?", a: "Oversized fit." },
  { q: "How do I choose my size?", a: "Use the Size Guide available on every product page." },
  { q: "How long does shipping take?", a: "Most Australian orders arrive within a few business days after dispatch." },
  { q: "Can I exchange my size?", a: "Yes, provided the item is unworn and returned in its original condition." },
  { q: "Do you ship internationally?", a: "Not yet." },
];

export default function FAQPage() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className="min-h-screen pt-32 pb-24 px-6 md:px-12" data-testid="faq-page">
      <SEO title="FAQ" description="Frequently asked questions about 3T products, shipping, sizing and returns." />
      <div className="max-w-[900px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <p className="font-mono text-[#FFD700] text-sm tracking-[0.3em] mb-2">SUPPORT</p>
          <h1 className="font-heading text-5xl md:text-7xl tracking-tight uppercase leading-[0.9]">
            FREQUENTLY ASKED <span className="text-[#FFD700]">QUESTIONS</span>
          </h1>
        </motion.div>

        <div className="space-y-0">
          {faqs.map((faq, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.08 }}
              className="border-b border-white/10"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between py-6 text-left bg-transparent border-none cursor-pointer group"
                data-testid={`faq-q-${i}`}
              >
                <span className="font-heading text-lg md:text-xl text-white group-hover:text-[#FFD700] transition-colors pr-4">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-[#FFD700] shrink-0 transition-transform duration-300 ${openIndex === i ? "rotate-180" : ""}`} />
              </button>
              <AnimatePresence>
                {openIndex === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.25 }}
                    className="overflow-hidden"
                  >
                    <p className="text-[#C0C0C0] text-base leading-relaxed pb-6 pl-0">
                      {faq.a}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
